<template>
  <div class="header">
    <div class="header-wrap flexBox">
      <div class="header-left">
        <img src="../../img/title.png" alt="" class="headerLogo">
      </div>
      <div class="header-right">
<!--        <span class="Date" style="color: red;" v-if="doctorType === 2 && caFlag == 'false'">-->
<!--          自动审方：<el-switch :value="selfSignFlag" size="large" @change="changeSelfSignFlag"-->
<!--                              style="&#45;&#45;el-switch-on-color: #0caf60;"></el-switch>-->
<!--        </span>-->
        <span class="Date">{{ nowTime }}</span>
        <div class="header-user-con">
          <!-- 用户名下拉菜单 -->
          <el-dropdown
              class="user-name"
              trigger="click"
              @command="handleCommand"
          >
            <div>
              <div class="user-avator" style="cursor: pointer">
                <img src="../../img/doctor.png"/>
              </div>
              <span class="el-dropdown-link" style="cursor: pointer">
                {{ doctorName }} <i class="el-icon-caret-bottom"></i>
              </span>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item divided command="changePassword"
              >修改密码
              </el-dropdown-item
              >
              <el-dropdown-item divided command="loginout"
              >退出登录
              </el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <el-dialog
        title="修改密码"
        :visible.sync="changePasswordForm"
        width="30%"
        center
        :close-on-click-modal="false"
    >
      <el-form
          ref="changePasswordList"
          :model="changePasswordList"
          :rules="rules"
          label-width="80px"
      >
        <el-form-item label="新密码" prop="newPassword">
          <el-input
              type="password"
              v-model="changePasswordList.newPassword"
              placeholder="请输入新密码"
              @keyup.native.enter="changePassword()"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
              type="password"
              v-model="changePasswordList.confirmPassword"
              placeholder="请再输入一次新密码"
              @keyup.native.enter="changePassword()"
          ></el-input>
        </el-form-item>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;密码必须是8位以上大小写字母、数字、特殊字符中的至少三种 </span>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changePasswordForm = false" type="success" plain>取 消</el-button>
        <el-button type="success" @click="changePassword()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="登出" :visible.sync="loginOutFlag" width="30%" center :close-on-click-modal="false">
      <div style="font-size:16px;text-align:center;">如确认退出当前账号，确认信息</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="loginOutFlag = false" type="success" plain>取 消</el-button>
        <el-button type="success" @click="loginOutEvent" v-loading="loading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import bus from "@/config/bus";
import {ChangepassWord, getInfo, LoginOut} from "../../api/index";
import store from "@/store/store";
import { closeSocket } from "@/utils/socket";
export default {
  name: "Header",
  data() {
    return {
      collapse: false,
      fullscreen: false,
      message: 2,
      changePasswordForm: false,
      changePasswordList: {
        id: "",
        newPassword: "",
        confirmPassword: "",
      },
      loginOutFlag: false,
      loginOutList: {},
      rules: {
        newPassword: [
          {required: true, message: "请输入新密码", trigger: "blur"},
        ],
        confirmPassword: [
          {required: true, message: "请输入确认密码", trigger: "blur"},
        ],
      },
      loginOutRules: {
        password: [{required: true, message: "请输入密码", trigger: "blur"}],
      },
      doctorName: "",
      tipsFlag: false,
      tipsMsg: "",
      nowTime: "",
      loading: false,
      caFlag: "",
      doctorType: "",
      selfSignFlag: false
    };
  },
  created() {
    getInfo().then((res) => {
      if (res.code === 0) {
        store.commit("SET_SELF_SIGN_FLAG", true);
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("doctor", res.data.doctor);
        localStorage.setItem("doctorEmployee", res.data.doctor.code);
        localStorage.setItem("doctorName", res.data.doctor.name);
        localStorage.setItem(
            "permissions",
            JSON.stringify(res.data.permissions)
        );
        store.commit("SET_DOCTOREMPLOYEENOTE", res.data.doctor.code);
        this.doctorType = res.data.doctor.type
        this.caFlag = localStorage.getItem("caFlag");
      }
    });
  },
  computed: {
    username() {
      let username = localStorage.getItem("ms_username");
      return username ? username : this.name;
    },
  },
  methods: {
    handleOpen() {
      this.$emit("changeCollapse");
    },
    // 用户名下拉菜单选择事件
    handleCommand(command) {
      if (command == "loginout") {
        this.loginOutFlag = true;
      }
      if (command == "changePassword") {
        this.changePasswordForm = true;
        this.$nextTick(() => {
          this.$refs["changePasswordList"].resetFields();
        });
      }
    },
    // 侧边栏折叠
    collapseChage() {
      this.collapse = !this.collapse;
      bus.$emit("collapse", this.collapse);
    },
    handleMsg() {
    },
    changePassword() {
      if (
          this.changePasswordList.oldPassword ===
          this.changePasswordList.newPassword
      ) {
        this.$message.error({
          message: "新旧密码不能相同，请重新修改密码！",
        });
        this.changePasswordList.oldPassword = "";
        this.changePasswordList.confirmPassword = "";
        this.changePasswordList.newPassword = "";
      } else if (
          this.changePasswordList.confirmPassword !==
          this.changePasswordList.newPassword
      ) {
        this.$message.error({
          message: "新密码与确认密码不相同，请重新确认修改！",
        });
        this.changePasswordList.oldPassword = "";
        this.changePasswordList.confirmPassword = "";
        this.changePasswordList.newPassword = "";
      } else {
        ChangepassWord(this.changePasswordList).then((data) => {
          if (data.code == 500) {
            this.$message({
              message: data.msg,
              type: "error",
            });
          } else {
            this.$message({
              message: "修改密码成功",
              type: "success",
            });
            this.changePasswordForm = false;
          }
        });
      }
    },
    loginOutEvent() {
      this.loading = true
      closeSocket(); 
      setTimeout(() => {
        this.loading = false
      }, 10000)
      LoginOut().then(data => {
        if (data.code == 0) {
          localStorage.removeItem("token");
          this.$router.push("/login");
        } else {
          this.errorTipsMsg(data.msg);
        }
        this.loading = false
      })
    },
    //时间
    getNowTime() {
      let speed = 1000;
      let that = this;
      let theNowTime = function () {
        that.nowTime = that.timeNumber();
      };
      setInterval(theNowTime, speed);
    },
    timeNumber() {
      let that = this;
      let today = new Date();
      let date =
          today.getFullYear() +
          "-" +
          this.twoDigits(today.getMonth() + 1) +
          "-" +
          this.twoDigits(today.getDate());
      let week = today.getUTCDay();
      switch (week) {
        case 0:
          week = "星期日";
          break;
        case 1:
          week = "星期一";
          break;
        case 2:
          week = "星期二";
          break;
        case 3:
          week = "星期三";
          break;
        case 4:
          week = "星期四";
          break;
        case 5:
          week = "星期五";
          break;
        case 6:
          week = "星期六";
          break;
      }
      let time =
          this.twoDigits(today.getHours()) +
          ":" +
          this.twoDigits(today.getMinutes()) +
          ":" +
          this.twoDigits(today.getSeconds());
      return date + "  " + week + "  " + time;
    },
    mountedTime() {
      let that = this;
      let today = new Date();
      let date =
          today.getFullYear() +
          "-" +
          that.twoDigits(today.getMonth() + 1) +
          "-" +
          that.twoDigits(today.getDate());
      let week = today.getUTCDay();
      switch (week) {
        case 0:
          week = "星期日";
          break;
        case 1:
          week = "星期一";
          break;
        case 2:
          week = "星期二";
          break;
        case 3:
          week = "星期三";
          break;
        case 4:
          week = "星期四";
          break;
        case 5:
          week = "星期五";
          break;
        case 6:
          week = "星期六";
          break;
      }
      let time =
          that.twoDigits(today.getHours()) +
          ":" +
          that.twoDigits(today.getMinutes()) +
          ":" +
          that.twoDigits(today.getSeconds());
      that.nowTime = date + "  " + week + "  " + time;
    },
    twoDigits(val) {
      if (val < 10) return "0" + val;
      return val;
    },
    errorTipsMsg(str) {
      this.tipsFlag = true;
      this.tipsMsg = str;
      setTimeout(() => {
        this.tipsFlag2 = false;
      }, 2000);
    },
  },
  mounted() {
    this.mountedTime();
    this.getNowTime();
    if (document.body.clientWidth < 1500) {
      this.collapseChage();
    }
    this.doctorName = localStorage.getItem("doctorName");
  },
};
</script>
<style>
.flexBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  margin-left: 20px;
  /* padding-top: 20px; */
  font-size: 20px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}

.btn .el-icon-menu {
  width: 100%;
  height: 100%;
  font-size: 26px;
}

.btn.el-button--small {
  padding: 0;
  margin-left: 10px;
}

.header-wrap {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.header-right {
  float: right;
}

.Date {
  margin-right: 30px;
}

.header-user-con {
  float: right;
}

.btn-fullscreen {
  position: relative;
  float: left;
  font-size: 24px;
  font-weight: 700;
  cursor: pointer;
  margin: 0 20px;
}

.btn-fullscreen-badge {
  position: absolute;
  right: 0px;
  top: 18px;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #f56c6c;
  color: #fff;
}

.btn-bell {
  float: left;
  margin-right: 20px;
  font-size: 20px;
  font-weight: 700;
}

.user-avator {
  float: left;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #ccc;
  overflow: hidden;
  margin-right: 20px;
  margin-top: 8px;
}

.user-avator img {
  width: 40px;
  height: 40px;
}

.user-name {
  float: left;
  margin-right: 50px;
  cursor: pointer;
}

.btn-bell {
  position: relative;
  width: 30px;
  height: 30px;
  text-align: center;
  border-radius: 15px;
  cursor: pointer;
}

.btn-bell-badge {
  position: absolute;
  /*right: 0;*/
  /*top: -2px;*/
  right: 2px;
  top: 18px;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #f56c6c;
  color: #fff;
}

.icon-email {
  width: 20px;
  height: 15px;
}

.el-dialog__header {
  color: rgba(0, 0, 0, 0.85);
}

.el-dialog__header .el-dialog__title {
  color: rgba(0, 0, 0, 0.85);
}

.el-dialog__header .el-dialog__headerbtn .el-icon-close {
  color: rgba(0, 0, 0, 0.85);
}

.el-dialog__header .el-dialog__headerbtn .el-icon-close:hover {
  color: #86d6af;
}

.el-dialog__header .el-dialog__headerbtn .el-icon-close:active {
  color: #86d6af;
}

body /deep/ .el-dropdown-menu {
  top: 48px !important;
  padding-top: 0px;
  padding-bottom: 0px;
  border-radius: 6px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;

  color: rgba(0, 0, 0, 0.85);
}

body /deep/ .el-dropdown-menu__item {
  padding: 4px 20px;
}

body /deep/ .el-dropdown-menu .el-dropdown-menu__item--divided {
  margin-top: 0px;
}

body /deep/ .el-dropdown-menu__item--divided:before {
  height: 0px;
}

body /deep/ .el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #9fffd052;
  color: #0caf60;
}

/* Microsoft Edge 适配 */
body .el-dropdown-menu {
  top: 48px !important;
  padding-top: 0px;
  padding-bottom: 0px;
  border-radius: 6px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;

  color: rgba(0, 0, 0, 0.85);
}

body .el-dropdown-menu__item {
  padding: 4px 20px;
}

body .el-dropdown-menu .el-dropdown-menu__item--divided {
  margin-top: 0px;
}

body .el-dropdown-menu__item--divided:before {
  height: 0px;
}

body .el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #9fffd052;
  color: #0caf60;
}

body .el-switch.is-checked .el-switch__core {
  background-color: #0caf60;
  border-color: #0caf60;
}

.headerLogo {
  /* vertical-align: middle; */
  margin-top: -6px;
  vertical-align: middle;
  height: 40px;
}
</style>
